import PropTypes from 'prop-types'

import {BASE_CLASS_NAME} from '../../config.js'

const TitleSellerPlate = ({description, title}) => {
  return (
    <>
      <h1 className={`${BASE_CLASS_NAME}-title`}>{title}</h1>
      {description ? <p className={`${BASE_CLASS_NAME}-titleDescription`}>{description}</p> : null}
    </>
  )
}

TitleSellerPlate.displayName = 'TitleSellerPlate'

TitleSellerPlate.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired
}

export default TitleSellerPlate
